import React from 'react';
import styled from 'styled-components';

/**
 * 선택 박스의 다운 이미지 
 */
const SelectArrowImgBlock = styled.div`
    content: '';
    display: inline-block;
    width: ${props => props.width || '24px'};
    height: ${props => props.height || '16px'};
    margin-left: 10px;
    background-image:url(${props => props.img});
    background-position: center;
    background-repeat: no-repeat;
    border: none;
`;

const SelectArrowImg = ({height, width }) => {
    return (
        <SelectArrowImgBlock img="/assets/images/icon/ds-icon.png" height={height} width={width}/>
    );
};

export default SelectArrowImg;